import { IAddress } from './address'

export interface IShop {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shortIdentifier: string
  name: string
  shopType: string
  address: IAddress
  phoneNumber: string
  emailAdress: string
  license: unknown
  enableDeliveryFee: boolean
  deliveryFee: number
  taxOrder: string
  taxInfo: TaxInfo
  showWalkInQueue: boolean
  showDeliveryQueue: boolean
  showOnlineQueue: boolean
  showSpecialQueue: boolean
  aliasQueueTypeName: unknown
  walkInQueueDOV: string
  deliveryQueueDOV: string
  specialQueueDOV: string
  enableCashInOut: boolean
  timeZone: string
  latitude: number
  longitude: number
  active: boolean
  snapshopTime: number
  nextSnapshotTime: number
  defaultCountry: string
  onlineStoreInfo: OnlineStoreInfo
  deliveryFees: unknown[]
  enableSaleLogout: boolean
  assets: unknown[]
  enableBCCReceipt: boolean
  bccEmailAddress: unknown
  enableGPSTracking: boolean
  receivingInventoryId: unknown
  defaultPinTimeout: number
  emailList: unknown[]
  enableLowInventoryEmail: boolean
  restrictedViews: boolean
  emailMessage: unknown
  taxRoundOffType: string
  enforceCashDrawers: boolean
  useAssignedEmployee: boolean
  termSalesOption: string
  showProductByAvailableQuantity: boolean
  autoCashDrawer: boolean
  numAllowActiveTrans: number
  requireValidRecDate: boolean
  enableDeliverySignature: boolean
  restrictIncomingOrderNotifications: boolean
  restrictedNotificationTerminals: unknown[]
  roundOffType: string
  roundUpMessage: unknown
  membersCountSyncDate: number
  enableCannabisLimit: boolean
  useComplexTax: boolean
  taxTables: TaxTable[]
  enableExciseTax: boolean
  exciseTaxType: string
  nalExciseFromRetailCost: boolean
  nalExciseAfterCityTax: boolean
  alExciseOnZeroPrice: boolean
  marketingSources: unknown[]
  productsTag: string[]
  logo: unknown
  hubId: unknown
  hubName: unknown
  enableOnFleet: boolean
  onFleetApiKey: unknown
  onFleetOrganizationId: unknown
  onFleetOrganizationName: unknown
  onFleetTwoWay: boolean
  onFleetTwoWayUpdateSchedule: boolean
  onFleetTwoWayRevert: boolean
  onFleetTwoAutoPack: boolean
  onFleetAllowEmptyOrders: boolean
  autoOnFleetTeam: string
  enableUnAssignedOnfleetOrder: boolean
  emailAttachment: unknown
  receiptInfo: unknown
  enableWooCommerce: boolean
  cartMinimums: CartMinimums
  creditCardFeeList: unknown[]
  blazePayFeeList: unknown[]
  strongholdFeeList: unknown[]
  achFeeList: unknown[]
  appTarget: IAppTarget
  twilioNumber: unknown
  enableAgeLimit: boolean
  ageLimit: number
  medicinalAge: number
  enableMedicinalAge: boolean
  deliveryRefundType: string
  creditFefundType: string
  enableSpringBig: boolean
  enableGrowthLoyalty?: boolean
  enableDailySummaryEmail: boolean
  enableHarvestTax: boolean
  enableTookan: boolean
  legalLanguage: unknown
  enableExciseTaxWarning: boolean
  exciseTaxWarning: unknown
  orderTags: string[]
  allowAnonymousOrders: boolean
  membersTag: unknown[]
  poTermCondition: unknown
  poNote: unknown
  invoiceTermCondition: unknown
  invoiceNote: unknown
  defaultHandOverMin: number
  draftOrderTimeout: number
  enableTip: boolean
  flowerType: string[]
  enableRefundNote: boolean
  enableAutoPrintAtFulfillment: boolean
  nonCannabisTaxes: NonCannabisTaxes
  appendBrandNameWM: boolean
  blazeConnections: unknown[]
  enableLimitOnNetWeight: boolean
  disableMedicalProductsForAdultUse: boolean
  disableRecreationalProductsForMedical: boolean
  enableDiscountNotes: boolean
  enableCartDiscountNotes: boolean
  enableAfterTaxDiscountNotes: boolean
  checkDuplicateDl: boolean
  onFleetRequired: boolean
  enableColorPin: boolean
  colorSameDay: string
  colorNextDay: string
  colorBeyondNextDay: string
  tookanRequired: boolean
  enableDOBNameUniqueness: boolean
  enableWaive: boolean
  enableCustomerIdentification: boolean
  enableComplianceTesting: boolean
  onfleetOverrideUrl: unknown
  enableTipsBlazePay: boolean
  enableIncomingOrders: boolean
  enableCommittedValidation: boolean
  enableMfg: boolean
  testShop: boolean
  billable: boolean
  validateRegion: boolean
  overrideMemberLimits: boolean
  requiredComplianceLabel: boolean
  enableQtyFlattening: boolean
  allowDelivery: boolean
  nalTaxesOnly: boolean
  enableSkipAssignValidation: boolean
  website: unknown
  dispatchConfiguration: DispatchConfiguration
  requirePhoneNumber: boolean
  requiredMemberPhone: boolean
  deliveryMaxOrders: number
  enableDeferTransactions: boolean
  pennyTransactionOption: string
  defaultMetrcLocation: unknown
  canAssignLocationsToPackages: boolean
  canUpdateLocationsOnPackages: boolean
  productPriceIncludeExciseTax: boolean
  checkoutType: string
  exciseTaxInfo: ExciseTaxInfo
  nonCannabisTaxInfo: NonCannabisTaxInfo
  timezoneOffsetInMinutes: number
}
export enum IAppTarget {
  RETAIL = 'Retail',
  GROW = 'Grow',
  DISPATCH = 'Dispatch',
  //TODO: Add other app targets
}
export interface TaxInfo {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  cityTax: number
  stateTax: number
  federalTax: number
  activeCDTFATax: boolean
}

export interface OnlineStoreInfo {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shopId: string
  dirty: boolean
  enableStorePickup: boolean
  enableDelivery: boolean
  enableOnlineShipment: boolean
  enableProductReviews: boolean
  colorTheme: string
  defaultETA: number
  pageOneMessageTitle: unknown
  pageOneMessageBody: unknown
  submissionMessage: unknown
  cartMinimum: number
  cartMinType: string
  enabled: boolean
  websiteOrigins: string
  supportEmail: string
  enableOnlinePOS: boolean
  enableDeliveryAreaRestrictions: boolean
  restrictedZipCodes: unknown[]
  useCustomETA: boolean
  customMessageETA: unknown
  storeHexColor: unknown
  viewType: string
  enableInventory: boolean
  validateInventory: string
  enableInventoryType: string
  activeInventoryId: unknown
  enableHtmlText: boolean
  htmlText: unknown
  websiteUrl: unknown
  enableOtherMarketingSource: boolean
  customCss: unknown
  denyBannedCustomers: boolean
}

export interface TaxTable {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shopId: string
  dirty: boolean
  name: string
  active: boolean
  taxType: string
  taxOrder: string
  consumerType: string
  cityTax: CityTax
  countyTax: CountyTax
  stateTax: StateTax
  federalTax: FederalTax
  enableSurchargeFeeTax: boolean
}

export interface CityTax {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: unknown
  shopId: unknown
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface CountyTax {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: unknown
  shopId: unknown
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface StateTax {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: unknown
  shopId: unknown
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface FederalTax {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: unknown
  shopId: unknown
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface CartMinimums {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  minimumsType: string
  cartMinimumDetails: unknown[]
}

export interface NonCannabisTaxes {
  taxOrder: string
  taxInfo: TaxInfo2
  useComplexTax: boolean
  taxTables: TaxTable2[]
  enableNonCannabisTax: boolean
  nonCannabisType: string
  nalExciseFromRetailCost: boolean
  alExciseOnZeroPrice: boolean
}

export interface TaxInfo2 {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  cityTax: number
  stateTax: number
  federalTax: number
  activeCDTFATax: boolean
}

export interface TaxTable2 {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shopId: string
  dirty: boolean
  name: string
  active: boolean
  taxType: string
  taxOrder: string
  consumerType: string
  cityTax: CityTax2
  countyTax: CountyTax2
  stateTax: StateTax2
  federalTax: FederalTax2
  enableSurchargeFeeTax: boolean
}

export interface CityTax2 {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shopId: string
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface CountyTax2 {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shopId: string
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface StateTax2 {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shopId: string
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface FederalTax2 {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  companyId: string
  shopId: string
  dirty: boolean
  taxRate: number
  compound: boolean
  active: boolean
  territory: string
  activeExciseTax: boolean
  taxOrder: string
  displayName: string
  activeDeliveryFeeTax: boolean
  displayAppendTax: boolean
  activeSurchargeTax: boolean
  activeCDTFATax: boolean
}

export interface DispatchConfiguration {
  autoAcceptMember: boolean
  autoAcceptIncomingOrders: boolean
  autoAcceptEmployee: string
  autoAssignIncomingOrders: boolean
  autoAssignOrders: boolean
  autoAssignDrivers: boolean
  autoPackedIncomingOrders: boolean
  autoPackedEmployee: string
}

export interface ExciseTaxInfo {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  state: string
  country: string
  stateMarkUp: number
  exciseTax: number
  cannabisTaxType: string
  active: boolean
  validAfter: number
}

export interface NonCannabisTaxInfo {
  id: string
  created: number
  modified: number
  deleted: boolean
  updated: boolean
  state: string
  country: string
  stateMarkUp: number
  exciseTax: number
  cannabisTaxType: string
  active: boolean
  validAfter: number
}

export enum ShopType {
  Medicinal = 'Medicinal',
  Recreational = 'Recreational',
  Both = 'Both',
}



// WEBPACK FOOTER //
// ./src/models/contracts/shop.ts